import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37f0e4ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-flex-column p-jc-center p-align-center container reset-password-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-mb-4" }, "Inserisci qui la tua nuova password", -1))
const _hoisted_3 = {
  key: 1,
  class: "p-d-flex p-flex-column p-jc-center p-align-center container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Reset password completata con successo!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!
  const _component_GVPassword = _resolveComponent("GVPassword")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, { position: "top-center" }),
    _createVNode(_component_GvSpinner, { "is-loading": _ctx.isLoading }, null, 8, ["is-loading"]),
    (!_ctx.resetPasswordCompleted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.resetPasswordCompleted)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.performResetPassword && _ctx.performResetPassword(...args)), ["prevent"])),
                class: "p-d-flex p-flex-column p-jc-center p-align-center container"
              }, [
                _hoisted_2,
                _createVNode(_component_GVPassword, {
                  class: "input-text p-mb-2",
                  "data-testid": "password-input",
                  "field-name": "Password",
                  type: "password",
                  id: "password",
                  style: {"width":"100%"},
                  errors: _ctx.v$.password.$silentErrors,
                  "is-dirty": _ctx.v$.password.$dirty,
                  modelValue: _ctx.v$.password.$model,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.password.$model) = $event))
                }, null, 8, ["errors", "is-dirty", "modelValue"]),
                _createVNode(_component_GVPassword, {
                  style: {"width":"100%"},
                  class: "input-text",
                  "data-testid": "confirm-password-input",
                  "field-name": "Confirm password",
                  id: "confirmPassword",
                  type: "password",
                  errors: _ctx.v$.confirmPassword.$silentErrors,
                  "is-dirty": _ctx.v$.confirmPassword.$dirty,
                  modelValue: _ctx.v$.confirmPassword.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.confirmPassword.$model) = $event))
                }, null, 8, ["errors", "is-dirty", "modelValue"]),
                _createVNode(_component_Button, {
                  "data-testid": "reset-password-button",
                  type: "submit",
                  label: "Reset password",
                  class: "gv-button reset-button p-mt-6",
                  disabled: _ctx.v$.$invalid
                }, null, 8, ["disabled"])
              ], 32))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.resetPasswordCompleted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Button, {
              class: "gv-button",
              label: "Vai al login",
              onClick: _ctx.goToLogin
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
  ], 64))
}